'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Paragraph } from '../Paragraph/Paragraph.js';

/**
 * FieldsetDescription component, used to display a description for a fieldset.
 *
 * @example
 * <Fieldset.Description>
 *   Gi en kort beskrivelse i begge feltene
 * </Fieldset.Description>
 */
const FieldsetDescription = forwardRef(function FieldsetDescription(rest, ref) {
    return jsx(Paragraph, { ref: ref, ...rest });
});

export { FieldsetDescription };
